import React, { useRef, useState } from 'react';

import { GET_ALL_DOMAINS_REQUEST } from 'js/constants/actionTypes';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';

import { ROUTE_DATA_DOMAINS } from 'new/constants/pathnames';
import { BannerDescription } from 'new/elements/BannerDescription';
import { DetailView } from 'new/elements/DetailView';
import { Table } from 'new/elements/Table';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { useModals } from 'new/hooks/useModals';
import { ScreenComponent, ScreenConfig } from 'new/routes/RouterManager';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';

import { ModalAddDomain } from '../components/ModalAddDomain/ModalAddDomain';
import { columns } from './columns';
import styles from './DataDomains.module.scss';
import { useUserDomains } from './useUserDomains';
import NoContentTextView from 'js/components/elements/NoContentTextView';

interface DataDomainsProps {}

const description =
  'A Domain caters to specific needs and data analysis use cases, empowering informed decision-making.';

export const DataDomains: ScreenComponent<DataDomainsProps> = () => {
  const { openModal } = useModals();
  const containerRef = useRef();
  const isLoading = useIsLoading(GET_ALL_DOMAINS_REQUEST);
  const { domains } = useUserDomains();
  const [selectedDomain, setSelectedDomain] = useState(null);
  const user = useCurrentUser();

  const onClickCreateDomain = () => openModal(ModalAddDomain.modalConfig.name);

  const onClickDomain = (domain) => {
    setSelectedDomain({ ...domain, type: 'DOMAIN' });
  };

  const onCloseDrawer = () => setSelectedDomain(null);

  if (!isLoading && !domains?.length) {
    return (
      <>
        <BannerDescription
          title="Data Domains"
          description={description}
          onClick={user.isOrgCustodian ? onClickCreateDomain : undefined}
          actionTitle={user.isOrgCustodian ? 'New Domain' : undefined}
        />
        <NoContentTextView
          title={<div>No Data Domains. Click on the button above to get started.</div>}
        />
      </>
    );
  }

  return (
    <div ref={containerRef} className={styles.dataDomainRootContainer}>
      <BannerDescription
        title="Data Domains"
        description={description}
        onClick={user.isOrgCustodian ? onClickCreateDomain : undefined}
        actionTitle={user.isOrgCustodian ? 'New Domain' : undefined}
      />
      <Table
        loading={isLoading}
        parentScrollRef={containerRef}
        columns={columns}
        rows={domains}
        onRowClick={onClickDomain}
      />
      <DetailView data={selectedDomain} showTransform={false} onClose={onCloseDrawer} />
    </div>
  );
};

DataDomains.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_DATA_DOMAINS}`,
  domain: 'marketplace',
  modals: [ModalAddDomain],
  header: {
    title: 'Data Domains',
    slugTitle: 'Data Domains',
  },
  screenName: 'DataDomains',
} as ScreenConfig<DataDomainsProps>;
